module.exports = __webpack_public_path__ + "img/photo-12.78e313e2.jpg";